import NodeModel from 'rise-ui/models/types/node.js';

import { attr } from '@ember-data/model';

export default class UiPageModel extends NodeModel {
  @attr('string') uuid;
  @attr('string') title;
  @attr('string') location;
}
